import React, {useState, useEffect} from 'react'
import ProgressIndicator from '../Indicator/ProgressIndicator';
import BottomPadding from '../BottomPadding/bottompadding';

const ProgramCommentsList = (id) => {

const [isloading, setLoading] = useState(true);
const [commentslist, setCommentsList] = useState();

const getProgramcommentlist = async (pi) => {
//    console.log(id);
        setLoading(true);
    const API_URL = `https://www.sasyavatagro.com/repos/api/dairyfarm/getprogramcomments/${pi}`;
    try{
        const response = await fetch(API_URL);
        if (!response.status) throw Error("Failed to fetch data");
        let valuelist = await response.json();
//       console.log(valuelist);      
        setCommentsList(valuelist);
    } catch (err) {
        console.log(err);
    } finally {
        setLoading(false);
    }

}

    useEffect(()=>{
             getProgramcommentlist(id.id);   
         window.scrollTo(0, 0);
             if (isloading) {
        }        
    },[]);

    return (
        <>

        {isloading && <ProgressIndicator />}
        {!isloading && 
        <div>
            <div style={{textAlign:'left', paddingLeft:'20px', backgroundColor:'lightskyblue', margin:'10px', height:'30px', lineHeight:'2.0'}}>
               <b> Program Comments</b>
            </div>
        {
            commentslist.map((item)=>(                
                <div key={item.commentid} style={{textAlign:'left', padding:'10px'}}>
                    <span><b> {item.CreateDate.substring(0,10)} </b> <br/><br/></span>
                   <span> {item.Comment} </span></div>
            ))
        }

        </div>}
           {/* <div style={{position:'relative', bottom:'0px',  height:'120px', width:'100vw', backgroundColor:'#F2EBEB'}}></div>  */}
<BottomPadding pad={'120px'} />
        </>
    );
}

export default ProgramCommentsList